import { observer } from "mobx-react";
import React from "react";
import { useHistory } from "react-router-dom";

import Button from "@/components/form/Button";
import { useMainStore } from "@/contexts/Store";
import Graphics from "@/images/congratulations-image/graphics.svg";
import logo from "@/images/logo.svg";

export function Congratulations() {
  const history = useHistory();
  const mainStore = useMainStore();
  const workspaceID = mainStore.users.user?.active_workspace?.id;

  function enterAdminPanel() {
    history.push(`/workspaces/${workspaceID}/home`);
  }

  return (
    <div className="congratulations-wrap">
      <a href="/" className="congratulations-logo">
        <img src={logo} alt="logo" />
      </a>
      <h3>Congratulations!</h3>
      <p>
        You have successfully created your account. Company setup can be
        completed in the admin portal.
      </p>
      <img src={Graphics} alt="congratulations-image" />
      <Button title="Enter Admin Portal" onClick={enterAdminPanel} />
    </div>
  );
}

export default observer(Congratulations);
